import firebase from 'firebase';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCk7PDMSZhnmXKloXfA9A66mLxZtYlc9hE",
    authDomain: "livechat-b2649.firebaseapp.com",
    projectId: "livechat-b2649",
    storageBucket: "livechat-b2649.appspot.com",
    messagingSenderId: "741253836749",
    appId: "1:741253836749:web:7681fa13697c1568605e84",
    measurementId: "G-X24CRY6ZKP"
  };

firebase.initializeApp(firebaseConfig);

const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const signIn = async () => {
  await auth.signInWithPopup(provider)
}
